import React, { useCallback, useEffect, useState } from "react";
import { HeroSm, NavBar, Spinner } from "../components";
import { Footer } from "../layouts";
import $ from "jquery";
import { Slang } from "../helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import config from "../config";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../store";
import { fetchWrapper } from "../helpers/fetch-wrapper";

const Contact = () => {
    const [loadPage, setLoadPage] = useState(true);

    useEffect(() => {
        let tim1 = setTimeout(() => {
            setLoadPage(false);
        }, 100);

        return () => {
            clearInterval(tim1);
        };
    }, []);

    return (
        <>
            {loadPage ? (
                <>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh",
                            width: "100%",
                            position: "fixed",
                            left: 0,
                            top: 0,
                        }}
                    >
                        <Spinner color={"success"} size={3} />
                    </div>
                </>
            ) : (
                <Main />
            )}

            {/*<Helmet>*/}
            {/*	/!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
            {/*	<title>Register your Business</title>*/}
            {/*	<link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
            {/*	<link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
            {/*	<link rel="stylesheet" href="./assets/css/_theme.css" />*/}

            {/*	<script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/prism/prism.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
            {/*	<script defer asyn src="./assets/js/theme.min.js"></script>*/}

            {/*</Helmet>*/}
        </>
    );
};

export default Contact;

const Main = () => {

    const [submitted, setSubmitted] = useState(false);
    const [token, setToken] = useState(null);
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const userToken = useSelector((state) => state.auth.token?.value);
    const [formData, setFormData] = useState({
        message: "",
        subject: "",
        phone: "",
        email: "",
        last_name: "",
        first_name: "",
        recaptchaToken: ""
    });

    const lang1 = Slang("Contact.sect1");
    const lang2 = Slang("Contact.sect2");

    const fetchUserInfo = async () => {
        try {
            const response = await axios.get('https://abn.happynessarl.com/api/v1/verify/user', {
                headers: {
                    'Authorization': `Bearer ${userToken}`
                }
            });
            const data = response.data.data;
            console.log('data:', data);
            setFormData({
                ...formData,
                email: data.email,
                first_name: data.full_name.split(" ")[0],
                last_name: data.full_name.split(" ")[1],
                phone: data.phone,
            })
        } catch (error) {
            console.error("Error fetching companies:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitted(true);
        const recaptchaToken = sessionStorage.getItem('reCaptchaToken')
        try {
            await axios.post('https://abn.happynessarl.com/api/v1/contacts/create', { ...formData, recaptchaToken });
            // Handle successful response or any other logic
            setSubmitted(false);
            toast.success(lang1('alert'))
            e.target.reset();

            setFormData({
                message: "",
                subject: "",
                phone: "",
                email: "",
                last_name: "",
                first_name: "",
                recaptchaToken: ""
            });

        } catch (error) {
            toast.error(lang1('error'))
            setSubmitted(false);
            setRefreshReCaptcha(r => !r);
            console.error(error);
        }
    };

    const onVerify = useCallback((token) => {
        sessionStorage.setItem('reCaptchaToken', token)
        setToken(token);
    }, []);

    useEffect(() => {

        fetchUserInfo()

        const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

        $("body").append(`<script className="homescript">${script}</script>`);

        return () => {
            $(".homescript").remove();
        };
    }, []);

    return (
        <>
            <NavBar />

            <HeroSm title={lang1('title')} />
            <main id="content" role="main">
                <div className="container content-space-6 content-space-t-lg-1 content-space-b-lg-3">
                    <div className="row">
                        <div className="col-md-4 mb-3 mb-md-0">
                            <a className="card card-transition text-center h-100" href="#">
                                <div className="card-body">
                                    <div className="svg-icon text-primary mb-3">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#035A4B" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M10.591 13.209V14.868H11.851C14.392 14.868 16.387 12.915 16.387 10.395C16.387 7.875 14.392 5.922 11.851 5.922C9.31 5.922 7.336 7.875 7.336 10.395H9.121C9.121 8.799 10.234 7.581 11.851 7.581C13.447 7.581 14.602 8.799 14.602 10.395C14.602 11.991 13.447 13.209 11.851 13.209H10.591ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z" fill="#035A4B" />
                                        </svg>

                                    </div>

                                    <h4 className="card-title">{lang1('t1')}</h4>
                                    <p className="card-text text-body">{lang1('cont1')}</p>
                                </div>

                                <div className="card-footer pt-0">
                                    <span className="card-link">{lang1('link1')}<i className="bi-chevron-right small ms-1"></i></span>
                                </div>
                            </a>
                        </div>


                        <div className="col-md-4 mb-3 mb-md-0">
                            <a className="card card-transition text-center h-100" href="#">
                                <div className="card-body">
                                    <div className="svg-icon text-primary mb-3">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M22.1671 18.1421C22.4827 18.4577 23.0222 18.2331 23.0206 17.7868L23.0039 13.1053V5.52632C23.0039 4.13107 21.8729 3 20.4776 3H8.68815C7.2929 3 6.16183 4.13107 6.16183 5.52632V9H13C14.6568 9 16 10.3431 16 12V15.6316H19.6565L22.1671 18.1421Z" fill="#035A4B" />
                                            <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M1.98508 18V13C1.98508 11.8954 2.88051 11 3.98508 11H11.9851C13.0896 11 13.9851 11.8954 13.9851 13V18C13.9851 19.1046 13.0896 20 11.9851 20H4.10081L2.85695 21.1905C2.53895 21.4949 2.01123 21.2695 2.01123 20.8293V18.3243C1.99402 18.2187 1.98508 18.1104 1.98508 18ZM5.99999 14.5C5.99999 14.2239 6.22385 14 6.49999 14H11.5C11.7761 14 12 14.2239 12 14.5C12 14.7761 11.7761 15 11.5 15H6.49999C6.22385 15 5.99999 14.7761 5.99999 14.5ZM9.49999 16C9.22385 16 8.99999 16.2239 8.99999 16.5C8.99999 16.7761 9.22385 17 9.49999 17H11.5C11.7761 17 12 16.7761 12 16.5C12 16.2239 11.7761 16 11.5 16H9.49999Z" fill="#035A4B" />
                                        </svg>

                                    </div>

                                    <h4 className="card-title">{lang1('t2')}</h4>
                                    <p className="card-text text-body">{lang1('cont2')}</p>
                                </div>

                                <div className="card-footer pt-0">
                                    <span className="card-link">{lang1('link2')}<i className="bi-chevron-right small ms-1"></i></span>
                                </div>
                            </a>
                        </div>


                        <div className="col-md-4">
                            <a className="card card-transition text-center h-100" href="#">
                                <div className="card-body">
                                    <div className="svg-icon text-primary mb-3">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5688 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5688 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="#035A4B" />
                                            <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="#035A4B" />
                                        </svg>

                                    </div>

                                    <h4 className="card-title">{lang1('t3')}</h4>
                                    <p className="card-text text-body">{lang1('cont3')}</p>
                                </div>

                                <div className="card-footer pt-0">
                                    <span className="card-link">{lang1('link3')}<i className="bi-chevron-right small ms-1"></i></span>
                                </div>
                            </a>
                        </div>

                    </div>

                    <div className="container content-space-2 content-space-lg-3">
                        <div className="mx-auto">
                            <div className="card">
                                <div className="card-body">

                                    <div className="text-center mb-5 mb-md-9">
                                        <h2>{lang2('title')}</h2>
                                        <p>{lang2('t1')}</p>
                                    </div>

                                    <form onSubmit={handleSubmit}>
                                        <div className="row gx-3">
                                            <div className="col-sm-6">

                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="hireUsFormFirstName">{lang2('t2')}</label>
                                                    <input required value={formData.first_name} type="text" className="form-control form-control-lg" name="first_name" onChange={handleChange} id="hireUsFormFirstName" placeholder={lang2('t2')} aria-label="First name" />
                                                </div>

                                            </div>

                                            <div className="col-sm-6">

                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="hireUsFormLasttName">{lang2('t3')}</label>
                                                    <input required value={formData.last_name} type="text" className="form-control form-control-lg" name="last_name" onChange={handleChange} id="hireUsFormLasttName" placeholder={lang2('t3')} aria-label="Last name" />
                                                </div>

                                            </div>

                                        </div>

                                        <div className="row gx-3">
                                            <div className="col-sm-6">

                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="hireUsFormWorkEmail">{lang2('t4')}</label>
                                                    <input required value={formData.email} type="email" className="form-control form-control-lg" name="email" onChange={handleChange} id="hireUsFormWorkEmail" placeholder="email@site.com" aria-label="email@site.com" />
                                                </div>

                                            </div>

                                            <div className="col-sm-6">

                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="hireUsFormPhone">{lang2('t5')} <span className="form-label-secondary">{lang2('t6')}</span></label>
                                                    <input required value={formData.phone} type="text" className="form-control form-control-lg" name="phone" onChange={handleChange} id="hireUsFormPhone" placeholder="+x(xxx)xxx-xx-xx" aria-label="+x(xxx)xxx-xx-xx" />
                                                </div>

                                            </div>

                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="hireUsFormSubject">{lang2('t10')}</label>
                                            <input required type="text" className="form-control form-control-lg" name="subject" onChange={handleChange} id="hireUsFormSubject" placeholder={lang2('t10')} aria-label="+x(xxx)xxx-xx-xx" />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="hireUsFormDetails">{lang2('t7')}</label>
                                            <textarea required className="form-control form-control-lg" name="message" onChange={handleChange} id="hireUsFormDetails" placeholder={lang2('ph')} aria-label="Tell us about your ..." rows="4"></textarea>
                                        </div>

                                        <GoogleReCaptchaProvider reCaptchaKey={config.googleReCaptchaClientId}>
                                            <GoogleReCaptcha
                                                className="google-recaptcha-custom-class"
                                                onVerify={onVerify}
                                                refreshReCaptcha={refreshReCaptcha}
                                            />
                                        </GoogleReCaptchaProvider>

                                        <div className="d-grid">
                                            <button disabled={submitted} type="submit" className="btn btn-primary btn-lg">{submitted ? <Spinner color="light" /> : lang2('t8')}</button>
                                        </div>

                                        <div className="text-center">
                                            <p className="form-text">{lang2('t9')}</p>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};
